// Titles
export const CUSTOM_BREAKPOINTS = 'Custom Breakpoints';
export const CALCULATED_BREAKPOINTS = 'Calculated Breakpoints';
export const BREAKPOINT_RANGE = 'Breakpoint Range';
export const BREAKPOINT_PRICE_PER_COMMON_SHARE = 'Breakpoint Price per Common Share';
export const TOTAL = 'Total';
